import React, { Fragment, useContext } from 'react';
import PropTypes, { shape } from 'prop-types';
import { Alert } from '@thd-olt-component-react/alert';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import {
  formatDistance,
  getSellableQuantityNearbyStore,
  getNearbyStoreInStock,
  productShape
} from '../../helpers/pod-fulfillment-utils';
import { CheckNearByStore } from './CheckNearbyStore';

export const InStockNearby = ({
  product,
  onCheckNearbyStoresClick
}) => {
  const { channel } = useContext(ExperienceContext);

  const nearbyStore = getNearbyStoreInStock(product);

  if (!nearbyStore) {
    return null;
  }

  const {
    distance,
    storeName,
    locationId: storeId
  } = nearbyStore;

  if (!(distance && storeName && storeId)) {
    return null;
  }

  const sellableQuantity = getSellableQuantityNearbyStore(product);
  if (!sellableQuantity) {
    return null;
  }

  return (
    <>
      <Alert type="success" inline>
        {sellableQuantity} <span className="store__alert--black">in stock at nearby store</span>
      </Alert>

      <div className="store__new-line">
        <span className="store__alert--green">{storeName}</span> | {formatDistance(distance)} miles away
      </div>
      {channel !== 'mobile' && (
        <div className="store__new-line">
          <CheckNearByStore
            product={product}
            onCheckNearbyStoresClick={onCheckNearbyStoresClick}
          />
        </div>
      )}
    </>
  );
};

InStockNearby.propTypes = {
  product: PropTypes.shape({ productShape }).isRequired,
  onCheckNearbyStoresClick: PropTypes.func,
};

InStockNearby.defaultProps = {
  onCheckNearbyStoresClick: null
};
